import i18n from '@/utils/i18n';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View, ViewStyle } from 'react-native';

const SKELETON_ROW_COUNT = 8;
const ROW_FADE_STEP = 0.1;

const CHECKBOX_SIZE = 20;
const ITEM_NAME_WIDTH = 160;
const ITEM_NAME_HEIGHT = 14;
const PACK_DETAILS_WIDTH = 96;
const PACK_DETAILS_HEIGHT = 10;

const getFadeStyle = (index: number): ViewStyle => ({
  opacity: 1 - index * ROW_FADE_STEP,
});

export const CatalogSearchSkeleton: React.FC = () => {
  const [styles, theme] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.order_guides_list.groups.catalog_search',
      )}
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
    >
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, rowIndex) => (
        <View key={rowIndex} style={[styles.row, getFadeStyle(rowIndex)]}>
          <AnimatedSkeletonLoader
            borderRadius={theme.sk.radii.radiusSmall}
            height={CHECKBOX_SIZE}
            width={CHECKBOX_SIZE}
          />
          <AnimatedSkeletonLoader
            borderRadius={theme.sk.radii.radiusMedium}
            height={theme.sk.spacing.space2xlarge}
            width={theme.sk.spacing.space2xlarge}
          />
          <View style={styles.text}>
            <AnimatedSkeletonLoader
              borderRadius={theme.sk.radii.radiusSmall}
              height={ITEM_NAME_HEIGHT}
              width={ITEM_NAME_WIDTH}
            />
            <AnimatedSkeletonLoader
              borderRadius={theme.sk.radii.radiusSmall}
              height={PACK_DETAILS_HEIGHT}
              width={PACK_DETAILS_WIDTH}
            />
          </View>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  row: {
    alignItems: 'center',
    borderBottomWidth: 1,
    borderColor: theme.sk.color.border.primary,
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
    paddingHorizontal: theme.sk.spacing.spaceSmall,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  text: {
    gap: theme.sk.spacing.spaceXsmall,
  },
}));
